//=> Import React
import React, { useState, useEffect } from "react";

//=> import plugins
import { BsSearch } from 'react-icons/bs';
import { FaUser } from 'react-icons/fa';
import { BsFillCartPlusFill } from 'react-icons/bs';
import { Link } from "gatsby"

// => Import Component =>
import SearchModal from '../SearchModal'

//=> Import Styles
import { navbar, content, links, link, button, buttonBar, navbarContainer, snipcartItemsCount } from "./styles.module.scss"





//=> Component
const NavBar = () => {

  const [count, setCount] = useState(0)
  useEffect(() => {
    // Le SDK de Snipcart fonctinne avec Redux, j'ai donc accès aux méthode store.subscribe() et store.getState() via Snipcart
    // J'initialise une variable pour stocker mon écouteur au store ce qui me permétra de me déshaboner
    let unsubscribe = null
    if (window) {
      // Au montage du composant, je récupère le nombre d'item dans le panier
      setCount(window.Snipcart.store.getState().cart.items.count)
      // Je m'abonne au store pour être au courant des que le nombre d'item du panier change
      unsubscribe = window.Snipcart.store.subscribe(() => {
        setCount(window.Snipcart.store.getState().cart.items.count)
      })
    }
    return unsubscribe
  })

  const [searchModalisOpen, setSearchModalIsOpen] = useState(false)

  const onCLickOpenModalSearch = () => {
    setSearchModalIsOpen(true)
  }

  const handlerOnKeyDown = (e) => {
    if (e.keyCode === 13) {
      setSearchModalIsOpen(true)
    }
  }

  return (
    <div className={navbarContainer}>
      <div className={navbar}>
        {/* SearchModal => */}
        {searchModalisOpen && <SearchModal closeModal={setSearchModalIsOpen} />}
        <div className={content}>
          <nav>
            <ul className={links}>
              <li className={link} ><Link title="Accueil" to="/">Accueil</Link></li>
              <li className={link} ><Link title="Boutique" to="/boutique">Boutique</Link></li>
              <li className={link} ><Link title="Atelier" to="/atelier">Atelier</Link></li>
              <li className={link} ><Link title="Information et contact" to="/info">Information et Contact</Link></li>
            </ul>
          </nav>
          <div className={buttonBar}>
            <button onClick={onCLickOpenModalSearch} onKeyDown={handlerOnKeyDown} className={button} aria-label="Faire une recherche" title="Faire une recherche" type="button"><BsSearch size="1.5em" /></button>
            <button className={`${button} snipcart-customer-signin`} title="Compte" aria-label="Compte" type="button"><FaUser size="1.5em" /></button>
            <button className={`${button} snipcart-checkout`} title="Panier" aria-label="Panier" type="button"><BsFillCartPlusFill size="1.5em" /> {count > 0 && <span className={`${snipcartItemsCount}`}>{count} </span>}</button>

          </div>

        </div>
      </div>
    </div>
  )
}

export default NavBar 